<div id="main"
     fxLayout="column"
     fxLayoutAlign="start start">

  <nav mat-tab-nav-bar
       mat-stretch-tabs="false"
       [tabPanel]="tabPanel">
    <a *ngFor="let link of navLinks"
       mat-tab-link
       [routerLink]="link.path"
       routerLinkActive
       #rla="routerLinkActive"
       [active]="rla.isActive">
      {{link.label}}
    </a>
  </nav>
  <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
  <mat-divider class="divider"></mat-divider>
  <ifc-app-scroll-container>
    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </ifc-app-scroll-container>

</div>
